var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useState } from 'react';
export const usePinningFlow = () => {
    _react_refresh_temp_1();
    const [pinRequest, setPinRequest] = useState(null);
    return {
        pinRequest,
        setPinRequest,
    };
};
_react_refresh_temp_1(usePinningFlow, "aXOqCyC6J73z5rNOpE8BjTTUZfA=");
